import { Checkbox, FormControlLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import CustomIcon from "components/customIcon";
import { Controller } from "react-hook-form";

const defaultSx = {
  width: "auto",
  label: {
    margin: "0",
  },
  ".PrivateSwitchBase-input": {},
  ".MuiFormControlLabel-label": {
    fontSize: "14px",
  },
  ".MuiCheckbox-root": {
    ".icon": {
      width: "30px",
      height: "30px",
      display: "inline-block",
      background: "rgba(13, 140, 235, 0.1)",
      borderRadius: "2px",
      img: {
        width: "16px",
        height: "12px",
        display: "inline-block",
      },
    },
  },
};

const CustomCheckbox = ({ label, onChange: onValueChange = () => "", labelPlacement = "start", error = false, disabled = false, options = [], fullWidth = true, defaultValue, sx = { mb: 2 }, ...props }) => {
  return (
    <Controller
      {...props}
      defaultValue={!!defaultValue}
      render={({ field: { onChange, ...fieldRest } }) => (
        <FormControl fullWidth={fullWidth} sx={{ ...defaultSx, ...sx }}>
          <FormControlLabel
            label={label}
            labelPlacement={labelPlacement}
            control={
              <Checkbox
                checked={!!fieldRest.value}
                labelPlacement={"end"}
                checkedIcon={<CustomIcon icon="check" />}
                icon={<div className="notchecked-icon" />}
                onChange={(e) => {
                  onChange(e.target.checked);
                  onValueChange(e.target.checked);
                }}
                {...fieldRest}
              />
            }
          />
        </FormControl>
      )}
    />
  );
};

export default CustomCheckbox;
